import { __assign, __spreadArrays } from "tslib";
import { combineReducers } from 'redux';
import types from '../state/types';
import { PresenceStatus } from '../types/types';
import * as _remove from 'lodash/remove';
import * as _isEmpty from 'lodash/isEmpty';
import { chatSdk } from './../api/chat-sdk';
import * as constants from '../constants/constants';
var calculateOnlineSessions = function (previousOnlineSessions, sessionId, status) {
    if (status === PresenceStatus.ONLINE) {
        return previousOnlineSessions.indexOf(sessionId) < 0 ? __spreadArrays(previousOnlineSessions, [sessionId]) : previousOnlineSessions;
    }
    else {
        return _remove(previousOnlineSessions, function (_sessionId) { return _sessionId !== sessionId; });
    }
};
var isPresenceDataValid = function (data) {
    var shouldValidatePresenceData = chatSdk.isExperimentOn(constants.experiments.ValidatePresenceData);
    return !shouldValidatePresenceData || (!_isEmpty(data) &&
        !_isEmpty(data.pageName) &&
        !_isEmpty(data.timestamp) &&
        !_isEmpty(data.location));
};
export function participantsById(state, action) {
    var _a;
    if (state === void 0) { state = {}; }
    if (action.type === types.UPDATE_PRESENCE) {
        var data = action.meta.data;
        var previousOnlineSessions = state[data.userId] ? state[data.userId].onlineSessions : [];
        var onlineSessions = calculateOnlineSessions(previousOnlineSessions, data.sessionId, data.status);
        if (!isPresenceDataValid(data.data)) {
            return state;
        }
        return __assign(__assign({}, state), (_a = {}, _a[data.userId] = {
            onlineSessions: onlineSessions,
            online: onlineSessions.length > 0,
            groupId: data.group,
            data: data.data,
        }, _a));
    }
    return state;
}
export var presenceReducer = combineReducers({
    participantsById: participantsById,
});
